<div data-testid="voice-recent-call_card" class="col-12 text-left p-1 mb-1">
    <telxl-panel
        [bodyClass]="'d-flex w-100 align-items-center py-2 px-2'"
        [cardClass]="isActiveInput() ? ' selected--green' : ''"
        [hover]="true"
    >
        <ng-template #cardBody>
            <div
                class="d-flex w-100 align-items-center justify-content-between"
            >
                <div class="d-flex">
                    <telxl-contact-icon [fullName]="customerNameForIcon()" />
                    <div
                        data-testid="voice-recent-call_contact-details"
                        class="d-flex flex-column ms-3 justify-content-center"
                    >
                        <div
                            [ngClass]="{
                                'weight-medium': callStatus().isUnknownCaller,
                                'mt-1': true,
                            }"
                        >
                            {{ customerPhoneNumber() | removebraces }}
                        </div>
                        <div
                            [ngClass]="{
                                'weight-medium': !callStatus().isUnknownCaller,
                            }"
                        >
                            <span class="me-2">{{ customerName() }}</span>
                        </div>
                    </div>
                </div>

                <div
                    class="d-flex align-items-center justify-content-between p-1 pt-2"
                >
                    <div class="text-end">
                        <div
                            data-testid="voice-recent-call_status"
                            class="d-flex align-items-center font-xs text-details"
                        >
                            <i
                                class="fa-lg fa-light me-2"
                                [ngClass]="callStatusClasses()"
                            ></i>
                            <span
                                class="ms-1"
                                [ngClass]="{
                                    'icon-red': callStatus().isMissedCall,
                                }"
                            >
                                {{ callStatus().label }}
                            </span>
                        </div>
                        <div
                            data-testid="voice-recent-call_information"
                            class="font-xs text-details mt-1"
                        >
                            {{ callSeconds | formatDuration }}s&nbsp;|&nbsp;{{
                                call().startTimeUtc | date: 'dd/MM/yy hh:mm a'
                            }}
                        </div>
                    </div>
                    <div class="ms-3 mr-1">
                        <button
                            type="button"
                            class="btn btn-no-border p-0 text-details"
                            (click)="selected()"
                            (keydown.enter)="selected()"
                            (keydown.space)="selected()"
                            tabindex="0"
                        >
                            <i
                                data-testid="voice-recent-call_phone-button"
                                class="fa-lg fa-light fa-phone"
                                [ngClass]="{
                                    'icon-sel fa-solid': isActiveInput(),
                                }"
                            ></i>
                        </button>
                    </div>
                </div>
            </div>
        </ng-template>
    </telxl-panel>
</div>
